import React from "react";
import { ThemeProvider } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";
import { muiTheme } from "@ovou-inc/ovou-ui/theme/mui";

// admin-front consumes the OVOU muiTheme verbatim (palette, typography,
// breakpoints, zIndex stack, and component overrides including MuiButton,
// MuiPaper, MuiIconButton, MuiDataGrid). No local overrides remain — every
// admin-specific tweak that used to live here has been promoted to ovou-ui
// so all consumers stay in sync.
let themeInstance: ReturnType<typeof createTheme> | null = null;

const getTheme = () => {
  if (!themeInstance) {
    themeInstance = createTheme(muiTheme);
  }
  return themeInstance;
};

interface MuiThemeWrapperProps {
  children: React.ReactNode;
  customTheme?: Theme;
}

export const MuiThemeWrapper: React.FC<MuiThemeWrapperProps> = ({
  children,
  customTheme,
}) => {
  const theme = customTheme || getTheme();
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
